import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import Toast from "../../../../common/toast";
import SessionExpired from "../../../../common/sessionExpired";
import apiCall from "../../../../../apicall";
import ClockInClockOutAdmin from "./clockin-clockout-admin";
import moment from "moment";
import Spinner from "../../../../common/spinner";
import ClockinClockoutPopup from "./clockin-clockout-popup";
import TableLoader from "../../../../common/tableLoader";
import ChatJobPopup from "./popup-chat";
import JobReviewRate from "./jobRatingReview";
import JobApproveTimePopup from "../../../../common/popups/popup-job-approve-time";
import DeleteClockinOutConfirmation from "./delete-confirmation-clockinout";
import EditClockInClockOutPopup from "./edit-clockin-clockout-popup";


const ClockInClockOut = ({ jobDetailsInfo, getJobDetailsData, hiredCandidatesLoader, hiredCandidatesList, approveAndFinishUserEntityId, getHiredCandidatesList }) => {
  const { TOKEN, role_type } = useSelector((state) => state.menu);
  const [sessionExpired, setSessionExpired] = useState(false);
  const [clockinClockoutLoader, setClockinClockoutLoader] = useState(false);
  const [isClockInLoading, setIsClockInLoading] = useState(false);
  const [isClockOutLoading, setIsClockoutLoading] = useState(false);
  const [clockinClockoutList, setClockInClockOutList] = useState([]);
  const [lastClockinClockoutItem, setLastClockinClockoutItem] = useState({});
  const [jobScheduleEntityId, setJobScheduleEntityId] = useState({});
  const [chatShow, setChatShow]=useState(false)
  const[selectedClockinClockout, setSelectedClockinClockout] = useState([]);
  const[applicantEntityId, setApplicantEntityId] = useState();
  const [selectedIds, setSelectedIds] = useState([]);
  const [isApproveTimeLoading, setIsApproveTimeLoading] = useState(false);
  const [selectedSeeker, setSelectedSeeker] = useState("");
  const [errSuccessMesg, setErrSuccessMsg] = useState({
    message: "",
    status: "error",
  });
  // console.log("hhhhh", jobDetailsInfo?.totalHours)
  console.log("hiredCandidatesList", jobDetailsInfo, hiredCandidatesList, selectedIds)
  const [updatedJobDetailInfo, setUpdatedJobDetailInfo] = useState(jobDetailsInfo)
  // let updatedJobDetailInfo=jobDetailsInfo
  // const approveBtnRef = useRef(null);
  
    const handleApproveAndFinish = (item) => {
      console.log("approveAndFinishUserEntityId",item)
      const isApprovedClockinout = clockinClockoutList?.some(item => item.approved);
      console.log("isApprovedClockinout",isApprovedClockinout);
      if(isApprovedClockinout){
       approveAndFinishUserEntityId(item)
      }else{
        displayErrMsg('Atleast one clockin-clockout must be approved.')
      }
      // Check the clockInStatus
      // if (jobEntity.clockInStatus === "Clocked In") {
      //   displayAppliedApplicantErrMsg("Job seeker must clock out before finishing the job.");
      //   return;
      // }
      // if (approveBtnRef.current) {
      //   approveBtnRef.current.setAttribute("data-bs-toggle", "modal");
      //   approveBtnRef.current.click();
      // }
    };

  const calculateTotalWorkingHour = (jobDetails_Data) => {
    const startDate = moment.utc(jobDetails_Data?.startTime); // Assuming start date is April 11, 2024, at 12:00 PM
    const endDate = moment.utc(jobDetails_Data?.endTime); // Assuming end date is April 12, 2024, at 2:30 PM
    const diffDuration = moment.duration(endDate.diff(startDate));
    const hours = diffDuration.hours();
    const minutes = diffDuration.minutes();
    return hours + " hours " + minutes + " minutes";
  };

  const displayErrMsg = (errMsg) => {
    setErrSuccessMsg({
      message: errMsg,
      status: false,
    });
  };

  const displaySuccessMsg = (errMsg) => {
    setErrSuccessMsg({
      message: errMsg,
      status: true,
    });
  };

  const handleEditClick = (record) =>{
      console.log("recordd=======",record)
      setSelectedClockinClockout(record)
  }

  const handleDeleteClick = (record) =>{
    console.log("recordd=======",record)
    setSelectedClockinClockout(record)
}

  const displayClockinoutErrMsg = (errMsg) => {
    setErrSuccessMsg({
      message: errMsg,
      status: false,
    });
  };
  const ConvertInto_Hrs = (hrs) => {
    var num = hrs
    console.log("num:::::", num)
    var str = num.toString();
    var numarray = str.split('.');
    var a = new Array();
    a = numarray;
    let minuteVal = Number(a[1]) / 60
    let strFnl = a[0] + (minuteVal.toString()).substring(1)
    return Number(strFnl).toFixed(2);
  }

  const getApprovedHours = () => {
    let totalMinutes = 0;

    clockinClockoutList?.forEach(item => {
      if (item.approved) {
        const checkin = new Date(item.checkinTime);
        const checkout = new Date(item.checkoutTime);
        const diffMs = checkout - checkin;
        const diffMins = diffMs / (1000 * 60); // convert ms to minutes
        totalMinutes += diffMins;
      }
    });

    const totalHoursDecimal = totalMinutes / 60;
    console.log("Converted Total Approved Time (hrs):", totalHoursDecimal);
    return totalHoursDecimal?.toFixed(2);
  }

  const getClockinClockout = async (hiredCandidatesId) => {
    console.log("jobDetailsInfo?.hirePerson", jobDetailsInfo?.hirePerson)
    console.log("jobDetailsInfojobDetailsInfo", jobDetailsInfo)
    try {
      setClockinClockoutLoader(true);
      const url = `${role_type.includes('ROLE_USER') ?
        `jobs/${jobDetailsInfo?.id}/clockinClockouts` :
        (role_type.includes("ROLE_OPENSTAFF_ADMIN") || role_type.includes("ROLE_OPENSTAFF_FINANCIAL_ADMIN"))
          ? `openstaff/jobs/${jobDetailsInfo?.id}/applicantClockinClockouts/${hiredCandidatesId}`
          : role_type.includes("ROLE_INSTITUTION_ADMIN") ?
          (jobDetailsInfo?.hirePerson ? 
            `institutions/jobs/${jobDetailsInfo?.id}/applicantClockinClockouts` :
            `institutions/jobs/${jobDetailsInfo?.id}/applicantClockinClockouts/${hiredCandidatesId}`)
            : ""
      }`;

      // const url = `jobs/${jobDetailsInfo?.id}/clockinClockouts`;
      const clockinClockoutResponse = await apiCall(url, "GET", null, TOKEN);
      console.log("add clockin clockout response", clockinClockoutResponse);
      if (clockinClockoutResponse?.status === 200) {
        const clockinoutres = clockinClockoutResponse.data.content;
        setClockinClockoutLoader(false);
        setClockInClockOutList(clockinoutres);
        if (clockinoutres?.length > 0) {
          setLastClockinClockoutItem(clockinoutres[clockinoutres.length - 1]);
          setJobScheduleEntityId(clockinoutres[clockinoutres.length - 1]?.jobScheduleEntityId)
        }
      } else if (clockinClockoutResponse?.response?.status == 401) {
        displayErrMsg("Your session has been expired!");
        setSessionExpired(true);
        setClockinClockoutLoader(false);
      } else {
        setSessionExpired(false);
        // displayErrMsg("Something went wrong!");
        displayErrMsg(clockinClockoutResponse?.response?.data?.message);
        setClockinClockoutLoader(false);
      }
      // Clear the map and address
    } catch (err) {
      setSessionExpired(false);
      setClockinClockoutLoader(false);

      displayErrMsg("Something went wrong!");
    }
  };

  const hirePersonId = jobDetailsInfo?.noOfHires > 1 ? applicantEntityId : jobDetailsInfo?.hirePerson?.id;
  const clockinClick = async (timeinout) => {
    const url = `openstaff/jobs/${jobDetailsInfo?.id}/clockIn/${hirePersonId}`;

    const clockinData = {
      // arrivalTime: moment.utc(new Date()).format('yyyy-MM-DD HH:mm:ss'),
      arrivalTime: moment.utc(timeinout).format('yyyy-MM-DD HH:mm:ss'),
      // location: { latitude: 29.749907, longitude: -95.358421 },
      notes: "",
    };

    console.log("clockin param",clockinData)

    try {
      setIsClockInLoading(true);
      const clockinResponse = await apiCall(url, "PUT", clockinData, TOKEN);
      console.log("clockinResponse--", clockinResponse);
      if (clockinResponse?.status === 200) {
        setIsClockInLoading(false);
        setSessionExpired(false);
        setErrSuccessMsg({
          message: "Clocked in Successfully!",
          status: "Success",
        });
        // getJobDetailsData();
        await getClockinClockout(selectedSeeker?.id);
        return clockinResponse?.data;
      } else if (clockinResponse?.response?.status == 401) {
        displayErrMsg("Your session has been expired!");
        setSessionExpired(true);
        setIsClockInLoading(false);
        return false;
      } else if (clockinResponse?.response?.status === 409) {
        setSessionExpired(false);
        displayErrMsg(clockinResponse?.response?.data?.errorMessage);
        setIsClockInLoading(false);
        return false;
      } else {
        setSessionExpired(false);
        // displayErrMsg("Something went wrong!");
        displayErrMsg(clockinResponse?.response?.data?.message);
        setIsClockInLoading(false);
        return false;
      }
    } catch (err) {
      setSessionExpired(false);
      displayErrMsg("Something went wrong!");
      setIsClockInLoading(false);
      return false;
    }
  };

  const clockoutClick = async (timeinout, adminClockinResponse) => {
    // const url = `openstaff/jobs/${jobDetailsInfo?.id}/clockOut/${hirePersonId}`;
    const url = `openstaff/jobs/${jobDetailsInfo?.id}/clockOut/${hirePersonId}/${adminClockinResponse?.clockInId || adminClockinResponse}`;
    const clockoutData = {
      // endTime: moment.utc(new Date()).format('yyyy-MM-DD HH:mm:ss'),
      endTime: moment.utc(timeinout).format('yyyy-MM-DD HH:mm:ss'),
      jobScheduleId: adminClockinResponse?.scheduleId || jobScheduleEntityId
      // location: { latitude: 29.749907, longitude: -95.358421 },
    };

    console.log("clockout param",clockoutData)


    try {
      setIsClockoutLoading(true);
      const clockoutResponse = await apiCall(url, "PUT", clockoutData, TOKEN);
      console.log("clockoutResponse====", clockoutResponse)
      if (clockoutResponse?.status === 200) {
        setIsClockoutLoading(false);
        setSessionExpired(false);
        setErrSuccessMsg({
          message: "Clocked out Successfully!",
          status: "Success",
        });
        getJobDetailsData();
        await getClockinClockout(selectedSeeker?.id);
        return true;
      } else if (clockoutResponse?.response?.status == 401) {
        displayErrMsg("Your session has been expired!");
        setSessionExpired(true);
        setIsClockoutLoading(false);
        return false;
      } else if (clockoutResponse?.response?.status === 409) {
        setSessionExpired(false);
        displayErrMsg(clockoutResponse?.response?.data?.errorMessage);
        setIsClockoutLoading(false);
        return false;
      } else {
        setSessionExpired(false);
        // displayErrMsg("Something went wrong!");
        displayErrMsg(clockoutResponse?.response?.data?.message);
        setIsClockoutLoading(false);
        return false;
      }
    } catch (err) {
      setSessionExpired(false);
      displayErrMsg("Something went wrong!");
      setIsClockoutLoading(false);
      return false;
    }
  };

  // Function to check if current time is between startTime and endTime
  const isCurrentTimeBetween = (startTimeISO, endTimeISO) => {
    const currentDate = new Date();
    const startTime = new Date(startTimeISO);
    const endTime = new Date(endTimeISO);
    return currentDate >= startTime && currentDate <= endTime;
  };

  // Function to handle clock-out based on job details
  const handleClockInClockOut =async (clockinout_type, timeinout, clockinId) => {
    // const startTime = moment.utc(jobDetailsInfo?.startTime).local();
    // const endTime = moment.utc(jobDetailsInfo?.endTime).local();
    // const singleDay = moment(startTime).isSame(moment(endTime), "day");
    console.log("clockinId======",clockinId)
    let adminClockinResponse = null;
    adminClockinResponse = clockinId;
    console.log("singleDay=====", clockinout_type)
    // if (isCurrentTimeBetween(startTime, endTime) && singleDay) {
    // if (singleDay) {
      // If single-day job, check if current time is between start and end time
      if (clockinout_type === "clockin") {
        // return clockinClick(timeinout);
        adminClockinResponse =  await clockinClick(timeinout);
        return adminClockinResponse;
      } else if (clockinout_type === "clockout") {
        return clockoutClick(timeinout, adminClockinResponse);
      }
      // } else if (
      //   !singleDay &&
      //   moment().isBetween(
      //     startTime.startOf("day"),
      //     endTime.endOf("day"),
      //     null,
      //     "[]"
      //   )
      // ) {
    // } else if (
      // !singleDay
      // moment().isBetween(
      //   startTime.startOf("day"),
      //   endTime.endOf("day"),
      //   null,
      //   "[]"
      // )
    // ) {
      // If multi-day job, check if current time is between or equal to start time or end time
    //   if (clockinout_type === "clockin") {
    //     return clockinClick(timeinout);
    //   } else if (clockinout_type === "clockout") {
    //     return clockoutClick(timeinout);
    //   }
    // }
    // else {
    //   displayClockinoutErrMsg(
    //     `${
    //       clockinout_type === "clockin" ? "Clock in" : "Clock out"
    //     } time must be between ${moment
    //       .utc(jobDetailsInfo?.startTime, "YYYY-MM-DD HH:mm:ss")
    //       .local()
    //       .format("hh:mm A")} and ${moment
    //         .utc(jobDetailsInfo?.endTime, "YYYY-MM-DD HH:mm:ss")
    //         .local()
    //         .format("hh:mm A")}!`
    //   );
    // }
  }

  const handleApproveTime = async (e) => {
      e.preventDefault();
        setIsApproveTimeLoading(true);
        console.log("selectedIds",selectedIds)
        const requestPayload = {
          "selectedClockInClockOutIds": selectedIds
        }
       
        try {
          const approveTimeResponse = await apiCall(
            `institutions/jobs/${jobDetailsInfo?.id}/approveSelectedClockInClockOut/${selectedSeeker?.userEntityId}`,
            "PUT",
            requestPayload,
            TOKEN
          );
          console.log("approveTimeResponse-----", approveTimeResponse);
          if (approveTimeResponse?.status === 200) {
            setErrSuccessMsg({
              message: "Time approved successfully!",
              status: true,
            });
            setSelectedIds([]);
            await getClockinClockout(selectedSeeker?.id); //refresh the list
            return true;
          } else if (approveTimeResponse?.response?.status == 406) {
            displayErrMsg(approveTimeResponse?.response?.data?.errorMessage);
            return false;
          } else {
            displayErrMsg(approveTimeResponse?.response?.data?.errorMessage)
            return false;
          }
        } catch (error) {
          displayErrMsg("Network error!");
          return false;
          console.error("Error:", error);
        } finally{
          setIsApproveTimeLoading(false);
        }
  };

  const handleUpdateClockinClockout =async (formValues, initialValues,selectedClockinClockout) =>{
    const requests = []; // Collect all the requests to send
    // Check if timeIn was updated
    if (formValues.timeIn && !moment(formValues.timeIn).isSame(initialValues?.timeIn)) {
      
      const updatedTimeInData = {
        arrivalTime: moment.utc(formValues.timeIn)
          .format("yyyy-MM-DD HH:mm:ss"),
        // location: {
        //   latitude: 29.749907,
        //   longitude: -95.358421,
        // },
        notes: "",
      };

      console.log("clockin params",updatedTimeInData)

      const timeInRequest = apiCall(
        `openstaff/jobs/${selectedClockinClockout?.id}/updateClockInClockOut`,
        "PUT",
        updatedTimeInData,
        TOKEN
      );
      requests.push(timeInRequest);
    }

    // Check if timeOut was updated
    if (formValues.timeOut && !moment(formValues.timeOut).isSame(initialValues?.timeOut)) {
      const updatedTimeOutData = {
        endTime: moment.utc(formValues.timeOut).format("yyyy-MM-DD HH:mm:ss"),
        // location: { latitude: 29.749907, longitude: -95.358421 },
      };

      console.log("clockout params",updatedTimeOutData)


      const timeOutRequest = apiCall(
        `openstaff/jobs/${selectedClockinClockout?.id}/updateClockInClockOut`,
        "PUT",
        updatedTimeOutData,
        TOKEN
      );
      requests.push(timeOutRequest);
    }

    // Ensure at least one field is updated
    if (requests.length === 0) {
      displayErrMsg("Please update either Time In or Time Out.");
      return;
    }

    try {
      // Perform all API requests
      const responses = await Promise.all(requests);
      console.log("response of time in time out", responses);
      // Check responses for success or failure
      const allSuccessful = responses.every(
        (response) => response.status === 200
      );
      if (allSuccessful) {
        setErrSuccessMsg({
          message: "Clock-in/Clock-out updated successfully.",
          status: true,
        });
        await getClockinClockout(selectedSeeker?.id);
      } else {
        displayErrMsg("Failed to update clock-in/clock-out.");
      }
    } catch (error) {
      displayErrMsg("An error occurred while updating the data.");
    }
}

const handleAppliedChatData = (applicant) => {
  setUpdatedJobDetailInfo({...jobDetailsInfo, hirePerson : applicant});
  // setChatShow(true);
};

  useEffect(() => {
    if (jobDetailsInfo?.id) {
      console.log("jobDetailsInfo::", jobDetailsInfo?.id, jobDetailsInfo?.jobStatus)
      // if (jobDetailsInfo?.jobStatus !== "eOpen" && jobDetailsInfo?.jobStatus !== "eCancelled" && (role_type?.includes("ROLE_USER") || role_type?.includes("ROLE_OPENSTAFF_ADMIN"))) {
      if (jobDetailsInfo?.jobStatus !== "eOpen" && jobDetailsInfo?.jobStatus !== "eCancelled" && (role_type?.includes("ROLE_USER"))) {
           getClockinClockout(selectedSeeker);
      }
    }
  }, [jobDetailsInfo]);

  useEffect(() => {
      if(selectedSeeker?.id){
       const selected_seeker =  hiredCandidatesList?.filter((item) => item?.id === selectedSeeker?.id);
       if(selected_seeker?.length > 0){
        setSelectedSeeker(selected_seeker[0]);
       }
       console.log("selected_seeker===", selected_seeker)
      }
  }, [hiredCandidatesList])

  // useEffect(() => {
  //   if (jobDetailsInfo?.jobStatus !== "eOpen" && jobDetailsInfo?.jobStatus !== "eCancelled" && (role_type?.includes("ROLE_INSTITUTION_ADMIN") && hiredCandidatesList?.length > 0)) {
  //      getClockinClockout(hiredCandidatesList[0]?.id);
  //   }
  // }, [hiredCandidatesList])

  // const ClockInClockOutDetails = () => {
  //   return (
  //    <>
  //     {role_type?.includes("ROLE_USER") && (
  //       jobDetailsInfo?.multipleDayJob ? (
  //         <div className="row m-b10 mb-5">
  //           <div className="col-md-6 col-12">
  //             <b>Work Hours: </b> {jobDetailsInfo?.totalHours}
  //           </div>
  //           <div className="col-md-6 col-12">
  //             <b>Logged Hours: </b> {jobDetailsInfo?.totalWorkedHours ? jobDetailsInfo?.totalWorkedHours : "0"}
  //           </div>
  //         </div>
  //         ) : (
  //         <div className="row m-b10 mb-5">
  //           <div className="col-md-6 col-12">
  //             <b>Total Hours: </b>
  //             {jobDetailsInfo?.totalHours ? ConvertInto_Hrs(jobDetailsInfo?.totalHours) : "0"}
  //           </div>
  //           <div className="col-md-6 col-12">
  //             <b>Logged Hours: </b> {jobDetailsInfo?.totalWorkedHours}
  //           </div>

  //         </div>
  //         )
  //       )}

  //       {(role_type.includes("ROLE_OPENSTAFF_ADMIN")) && (jobDetailsInfo?.jobStatus !== "eOpen" && jobDetailsInfo?.jobStatus !== "eCancelled" && jobDetailsInfo?.jobStatus !== "eCompleted") &&
  //       <div className="product-filter-wrap d-flex justify-content-between align-items-center">
  //         <h4 className="twm-s-title">Clock In/ Clock Out:</h4>
  //         <a
  //           className="site-button"
  //           data-bs-toggle="modal"
  //           href={"#clockin_clockout_popup"}
  //           role="button"
  //         >
  //           Add
  //         </a>
  //       </div>
  //       }
  //       {/* <p class="h4">Clock In/ Clock Out</p> */}

  //       {
  //       clockinClockoutLoader ? 
  //         <div className="mt-5"> 
  //           <Spinner size="lg" /> 
  //         </div>
  //       :
  //       clockinClockoutList?.length > 0 ? (
  //       <ClockInClockOutAdmin
  //         clockinClockoutLoader={clockinClockoutLoader}
  //         clockinClockoutList={clockinClockoutList}
  //         jobDetailsInfo={jobDetailsInfo}
  //         getJobDetailsData={getJobDetailsData}
  //         selectedClockinClockout={selectedClockinClockout}
  //         handleDeleteClick={handleDeleteClick}
  //         handleEditClick={handleEditClick}
  //         handleUpdateClockinClockout={handleUpdateClockinClockout}
  //       />
  //       ) : (
  //       <div className="tw-faq-section mt-5">
  //         <div className="accordion tw-faq" id="sf-faq-accordion-2">
  //           <h3 style={{ color: "red" }}>
  //             No Job History Found!
  //           </h3>
  //         </div>
  //       </div>
  //       )}
  //     </>
  //   )
  // }

  return (
    <>
      {
        (role_type.includes("ROLE_OPENSTAFF_ADMIN")) && (jobDetailsInfo?.jobStatus !== "eOpen" && jobDetailsInfo?.jobStatus !== "eCancelled" && jobDetailsInfo?.jobStatus !== "eCompleted") &&
        <ClockinClockoutPopup
          jobDetailsInfo={jobDetailsInfo}
          lastClockinClockoutItem={lastClockinClockoutItem}
          isClockInLoading={isClockInLoading}
          isClockOutLoading={isClockOutLoading}
          handleClockInClockOut={handleClockInClockOut}
          errSuccessMesg={errSuccessMesg}
          clockinClockoutLoader={clockinClockoutLoader}
          selectedClockinClockout={selectedClockinClockout}
          handleUpdateClockinClockout={handleUpdateClockinClockout}
        />
      }
      {/* {
      (role_type.includes("ROLE_OPENSTAFF_ADMIN")) && (jobDetailsInfo?.jobStatus !== "eOpen" && jobDetailsInfo?.jobStatus !== "eCancelled" && jobDetailsInfo?.jobStatus !== "eCompleted")  &&
      <div class="container mb-5">
      <div class="row justify-content-center align-items-center">
        <div class="col-md-auto">
          <p class="h4">{moment().format("dddd, MMMM D, YYYY")}</p>
        </div>
      </div>
      <div class="row justify-content-center align-items-center mt-2">
        <div class="col-md-auto text-center">
          <span class="text-muted">Clock-in</span>
          <span class="text-muted d-block" style={{ fontSize: 10 }}>
            {lastClockinClockoutItem?.checkinTime
              ? moment.utc(lastClockinClockoutItem?.checkinTime, "YYYY-MM-DD HH:mm:ss").local().format(
                  "MM-DD-YYYY"
                )
              : ""}
          </span>
          <p class="text-muted h4">
            {lastClockinClockoutItem?.checkinTime
              ? moment.utc(lastClockinClockoutItem?.checkinTime, "YYYY-MM-DD HH:mm:ss").local().format("hh:mm A")
              : "-"}
          </p>
        </div>
        <div class="col-md-auto text-center ml-5">
          {lastClockinClockoutItem?.checkinTime ? (
            <i
              class="fa fa-check-square"
              style={{
                color: "green",
                padding: "0px 30px",
                fontSize: "30px",
              }}
              aria-hidden="true"
            ></i>
          ) : (
            <button
              type="button"
              className="site-button"
              onClick={() => handleClockInClockOut("clockin")}
            >
              {isClockInLoading ? <Spinner /> : "Clock In"}
            </button>
          )}
        </div>
      </div>
      <div class="row justify-content-center align-items-center mt-3">
        <div class="col-md-auto text-center">
          <span class="text-muted">Clock-out</span>
          <p class="text-muted h4">-</p>
        </div>
        <div class="col-md-auto text-center ml-5">
          <button
            type="button"
            className="site-button"
            onClick={() => handleClockInClockOut("clockout")}
            disabled={lastClockinClockoutItem?.checkinTime ? false : true}
          >
            {isClockOutLoading ? <Spinner /> : "Clock Out"}
          </button>
        </div>
      </div>
    </div>
    } */}

      {/* {!(hiredCandidatesLoader && role_type.includes("ROLE_USER")) ? (
        hiredCandidatesList?.length > 0 ? (
          hiredCandidatesList?.map((item, index) => (
            <div key={item?.id} className="tw-faq-section" style={{ maxWidth: "100%" }} 
            >
              <div className="accordion tw-faq" id={`sf-faq-accordion-${index}`}>
                <div className="accordion-item" >
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target={`#hireApplicant-${index}`}
                    aria-expanded="false"
                    aria-controls={`hireApplicant-${index}`}
                    onClick={() => getClockinClockout(item?.id)}
                  >
                    {item.firstName} {item.lastName}
                  </button>
                  <div
                    id={`hireApplicant-${index}`}
                    className="accordion-collapse collapse"
                    data-bs-parent={`#sf-faq-accordion-${index}`}
                  >
                    <div className="accordion-body">
                      <ClockInClockOutDetails />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))
        ) : (
          "No results found."
        )
      ) : (
        <TableLoader />
      )} */}

{!(hiredCandidatesLoader && role_type.includes("ROLE_USER")) ? (
        hiredCandidatesList?.length > 0 ? (
          <div className="tw-faq-section" id="sf-faq-accordion">
            {hiredCandidatesList?.map((item, index) => (
              <div key={item?.id} className="accordion tw-faq" style={{ maxWidth: "100%" }}>
                <div className="accordion-item">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target={`#hireApplicant-${index}`}
                    aria-expanded="false"
                    aria-controls={`hireApplicant-${index}`}
                    // onClick={() => getClockinClockout(item?.id)}
                    onClick={(e) => {
                      const isCollapsed = e.currentTarget.getAttribute("aria-expanded") === "true";
                      if (isCollapsed) {
                        getClockinClockout(item?.id);
                        setSelectedSeeker(item);
                      }
                    }}
                  >
                    {item.firstName} {item.lastName} 
                    <span>{item?.jobFinished && <i class="fas fa-check-circle check-icon ms-3"></i>}</span>
                  </button>
                  <div
                    id={`hireApplicant-${index}`}
                    className="accordion-collapse collapse"
                    data-bs-parent="#sf-faq-accordion"
                  >
                    <div className="accordion-body">
                      {
                          // hiredCandidatesList?.length > 1 ?
                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 row">
                          <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 twm-job-self-bottom">
                            <div className="row">
                            {jobDetailsInfo?.multipleDayJob ? (
                                <>
                                  <div className="col-md-6 col-12">
                                    <b>Work Hours: </b> {jobDetailsInfo?.totalHours}
                                  </div>
                                  <div className="col-md-6 col-12">
                                    <b>Logged Hours: </b> {item?.totalWorkedHours ? item?.totalWorkedHours : "0"}
                                  </div>
                                </>
                            ) : (
                              <>
                                <div className="col-md-6 col-12">
                                  <b>Total Hours: </b>
                                  {jobDetailsInfo?.totalHours ? ConvertInto_Hrs(jobDetailsInfo?.totalHours) : "0"}
                                </div>
                                <div className="col-md-6 col-12">
                                  <b>Logged Hours: </b> {item?.totalWorkedHours || "0"}
                                </div>
                                {/* } */}
                              </>
                            )}
                             <div className="col-md-6 col-12">
                                    <b>Approved Hours: </b> {getApprovedHours()}
                             </div>
                          </div>
                          </div>
                          <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 twm-job-self-bottom text-end">
                          {/* {jobDetailsInfo?.jobStatus == "eInProgress" && item?.clockInStatus === "Clocked Out" && !item?.approved && ( */}
                          {jobDetailsInfo?.jobStatus == "eInProgress" &&  !item?.jobFinished  && role_type?.includes("ROLE_INSTITUTION_ADMIN") && (
                              <span style={{ marginRight: "5px" }}><button
                              className="site-button button-sm"
                              href={"#job-approve-time-popup"}
                              data-bs-toggle="modal"
                              role="button"
                              disabled={selectedIds?.length == 0}
                            >
                              Approve Time
                            </button></span>
                             )} 
                            {jobDetailsInfo?.jobStatus == "eInProgress" && role_type?.includes("ROLE_INSTITUTION_ADMIN") && !item?.jobFinished && (
                              <span style={{ marginRight: "5px" }}><a
                              className="site-button button-sm"
                              // href={"#job-review-popup"}
                              // data-bs-toggle="modal"
                              href={clockinClockoutList?.some(i => i?.approved) ? "#job-review-popup" : undefined}
                              data-bs-toggle={clockinClockoutList?.some(i => i?.approved) ? "modal" : ""}
                              role="button"
                              onClick={() => handleApproveAndFinish(item)} // Handle the click event
                            >
                              Finish Job
                            </a></span>
                           )} 
                            {item?.jobFinished && (
                                <span style={{ color: "green", marginRight: "20px" }} >
                                  COMPLETED JOB
                                </span>
                              )}
                            {(jobDetailsInfo?.jobStatus == "eAccepted" || jobDetailsInfo?.jobStatus == "eInProgress"|| jobDetailsInfo?.jobStatus=="eApplied") && 
                            (<span><a 
                              key={item.id}
                              className="site-button button-sm"
                              data-bs-toggle="modal"
                              role="button"
                              href={`#chatModal`}
                              onClick={() => handleAppliedChatData(item)}
                            >
                              <i className="far fa-comment fa-lg p-0" />
                            </a></span>
                             )} 
                          </div>  
                          {item?.jobFinished && (
                          <JobReviewRate 
                          displayErrMsg={displayErrMsg}
                          displaySuccessMsg={displaySuccessMsg}
                          currentPage={'approveFinishIndividual'}
                          hiredCandidatesList={hiredCandidatesList}
                          jobDetailId={jobDetailsInfo?.id}
                          userEntityId={item?.userEntityId}
                          getJobDetailsData={getJobDetailsData}
                          getHiredCandidatesList={getHiredCandidatesList}
                          applicantListItem={item}
                          />)}         
                        </div>
                        // :
                        // hiredCandidatesList?.length === 1 &&
                        // (<div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 row">
                        //   <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12">
                        //   </div>
                        //   <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 text-end">
                        //     {
                        //       (jobDetailsInfo?.jobStatus == "eAccepted" || jobDetailsInfo?.jobStatus == "eInProgress"|| jobDetailsInfo?.jobStatus=="eApplied") && (<span><a
                        //         key={item.id}
                        //         className="site-button"
                        //         data-bs-toggle="modal"
                        //         role="button"
                        //         href={`#chatModal`}
                        //         onClick={() => handleAppliedChatData(item)}
                        //       >
                        //         <i className="far fa-comment fa-lg" />
                        //       </a></span>)
                        //     }
                        //   </div>
                        // </div>)
                       } 

                       {role_type?.includes("ROLE_USER") && (
                        jobDetailsInfo?.multipleDayJob ? (
                          <div className="row m-b10 mb-5">
                            <div className="col-md-6 col-12">
                              <b>Work Hours: </b> {jobDetailsInfo?.totalHours}
                            </div>
                            <div className="col-md-6 col-12">
                              <b>Logged Hours: </b> {jobDetailsInfo?.totalWorkedHours ? jobDetailsInfo?.totalWorkedHours : "0"}
                            </div>
                          </div>
                          ) : (
                          <div className="row m-b10 mb-5">
                            <div className="col-md-6 col-12">
                              <b>Total Hours: </b>
                              {jobDetailsInfo?.totalHours ? ConvertInto_Hrs(jobDetailsInfo?.totalHours) : "0"}
                            </div>
                            <div className="col-md-6 col-12">
                              <b>Logged Hours: </b> {jobDetailsInfo?.totalWorkedHours}
                            </div>

                          </div>
                          )
                        )}

                        {(role_type.includes("ROLE_OPENSTAFF_ADMIN")) && (jobDetailsInfo?.jobStatus !== "eOpen" && jobDetailsInfo?.jobStatus !== "eCancelled" && jobDetailsInfo?.jobStatus !== "eCompleted") &&
                        <div className="product-filter-wrap d-flex justify-content-between align-items-center">
                          <h4 className="twm-s-title">Clock In/ Clock Out:</h4>
                          <a
                            className="site-button"
                            data-bs-toggle="modal"
                            href={"#clockin_clockout_popup"}
                            role="button"
                            onClick={() => setApplicantEntityId(item?.id)}
                          >
                            Add
                          </a>
                        </div>
                        }
                        {/* <p class="h4">Clock In/ Clock Out</p> */}



                        {
                        clockinClockoutLoader ? 
                          <div className="mt-5"> 
                            <Spinner size="lg" /> 
                          </div>
                        :
                        clockinClockoutList?.length > 0 ? (
                        <ClockInClockOutAdmin
                          clockinClockoutLoader={clockinClockoutLoader}
                          clockinClockoutList={clockinClockoutList}
                          jobDetailsInfo={jobDetailsInfo}
                          getJobDetailsData={getJobDetailsData}
                          selectedClockinClockout={selectedClockinClockout}
                          handleDeleteClick={handleDeleteClick}
                          handleEditClick={handleEditClick}
                          handleUpdateClockinClockout={handleUpdateClockinClockout}
                          selectedIds={selectedIds}
                          setSelectedIds={setSelectedIds}
                          selectedSeeker={selectedSeeker}
                        />
                        ) : (
                        <div className="tw-faq-section mt-5">
                          <div className="accordion tw-faq" id="sf-faq-accordion-2">
                            <h3 style={{ color: "red" }}>
                              No Job History Found!
                            </h3>
                          </div>
                        </div>
                        )}
                      {/* <ClockInClockOutDetails /> */}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          ""
        )
      ) : (
        <TableLoader />
      )}

      {role_type.includes("ROLE_USER") && (
        <div className="tw-faq-section" id="sf-faq-accordion">
          <div className="accordion tw-faq" style={{ maxWidth: "100%" }}>
            <div className="accordion-item">
              <button
                className="accordion-button"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target={`#hireApplicant-1`}
                aria-expanded="true"
              >
              </button>
              <div
                id={`hireApplicant-1`}
                className="accordion-collapse collapse show"
                data-bs-parent="#sf-faq-accordion"
              >
                <div className="accordion-body">
                  {
                    clockinClockoutLoader ?
                      <div className="mt-5">
                        <Spinner size="lg" />
                      </div>
                      :
                      clockinClockoutList?.length > 0 ? (
                        <ClockInClockOutAdmin
                          clockinClockoutLoader={clockinClockoutLoader}
                          clockinClockoutList={clockinClockoutList}
                          jobDetailsInfo={jobDetailsInfo}
                          getJobDetailsData={getJobDetailsData}
                          selectedClockinClockout={selectedClockinClockout}
                          handleDeleteClick={handleDeleteClick}
                          handleEditClick={handleEditClick}
                          handleUpdateClockinClockout={handleUpdateClockinClockout}
                          selectedIds={selectedIds}
                          setSelectedIds={setSelectedIds}
                        />
                      ) : (
                        <div className="tw-faq-section mt-5">
                          <div className="accordion tw-faq" id="sf-faq-accordion-2">
                            <h3 style={{ color: "red" }}>
                              No Job History Found!
                            </h3>
                          </div>
                        </div>
                      )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

    {/* {
      role_type.includes("ROLE_USER") &&  <ClockInClockOutDetails />
    } */}
     
     <JobApproveTimePopup selectedSeeker={selectedSeeker} isApproveTimeLoading={isApproveTimeLoading} handleApproveTime={handleApproveTime}/>
     <ChatJobPopup jobDetailsInfo={updatedJobDetailInfo}/>
     <DeleteClockinOutConfirmation selectedClockinClockout={selectedClockinClockout} getJobDetailsData={getJobDetailsData} getClockinClockout={getClockinClockout} selectedSeeker={selectedSeeker} />
     <EditClockInClockOutPopup selectedClockinClockout={selectedClockinClockout} handleUpdateClockinClockout={handleUpdateClockinClockout} getJobDetailsData={getJobDetailsData} />

      {errSuccessMesg?.message != "" ? <Toast message={errSuccessMesg} /> : ""}
      {sessionExpired && <SessionExpired />}
    </>
  );
};

export default ClockInClockOut;
